import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import NotificationClose from './NotificationClose';
import { Body, Fonts } from '@vds-core/typography';
import { withVDSManager, calculateRem } from '@vds-core/utilities';
import { ColorTokens } from '@vds-tokens/color';
import { LayoutTokens } from '@vds-tokens/layout';
import { TypographyTokens } from '@vds-tokens/typography';
import { ButtonGroup } from '@vds-core/buttons';
import { AccessibilityTokens } from '@vds-tokens/accessibility';
import { getBrowser, breakpoints, checkIfMobileDevice, generateUUID } from '@vds-core/utilities';

// Use checkmark-alt.svg
var SuccessIcon = /*#__PURE__*/React.createElement("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.6 21.6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.80009,19.80015a9,9,0,1,1,9-9A9.01054,9.01054,0,0,1,10.80009,19.80015Zm0-16.87512a7.87512,7.87512,0,1,0,7.87512,7.87512A7.88411,7.88411,0,0,0,10.80009,2.925ZM14.75,8.63964,13.95474,7.85,9.62367,12.17072,7.64331,10.20631,6.85,10.9979,9.62562,13.75Z"
}));

// Use error.svg
var ErrorIcon = /*#__PURE__*/React.createElement("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.6 21.6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.80213,19.80122a2.39567,2.39567,0,0,1-1.705-.707L2.50743,12.50444a2.41244,2.41244,0,0,1,0-3.40913L9.09808,2.50555a2.4159,2.4159,0,0,1,3.40908-.001l6.58967,6.59073a2.41244,2.41244,0,0,1,0,3.40913L12.50716,19.0942A2.394,2.394,0,0,1,10.80213,19.80122Zm-7.4998-9.911a1.289,1.289,0,0,0,0,1.81931L9.893,18.29929a1.31476,1.31476,0,0,0,1.81928,0l6.58967-6.58976a1.289,1.289,0,0,0,0-1.81931L11.71226,3.30047a1.29076,1.29076,0,0,0-1.81928,0ZM9.95,15.05h1.7V13.367H9.95Zm0-6.00953.561,2.635h.56952l.56951-2.635V6.55H9.95Z"
}));

// Use warning.svg
var WarningIcon = /*#__PURE__*/React.createElement("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.6 21.6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.52557,15.78473,12.588,3.74951a2.0643,2.0643,0,0,0-3.584-.001L2.0733,15.78668a2.07277,2.07277,0,0,0,1.79688,3.10358H17.73157a2.07289,2.07289,0,0,0,1.794-3.10553ZM18.548,17.2926a.9494.9494,0,0,1-.81738.47266H3.87115a.94838.94838,0,0,1-.82226-1.419L9.97961,4.30811a.9396.9396,0,0,1,1.63184,0L18.551,16.34625A.95147.95147,0,0,1,18.548,17.2926ZM9.95,14.367h1.7V16.05H9.95Zm0-6.817h1.7v2.49048l-.56951,2.635H10.511l-.561-2.635Z"
}));

// Use info.svg
var InfoIcon = /*#__PURE__*/React.createElement("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.6 21.6"
}, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
  "class": "cls-1",
  d: "M19.8,10.8a9,9,0,1,0-9,9A9.01054,9.01054,0,0,0,19.8,10.8Zm-1.12488,0A7.87513,7.87513,0,1,1,10.8,2.92486,7.88411,7.88411,0,0,1,18.67509,10.8ZM11.625,7.45852H9.95v-1.675h1.675ZM9.95834,9.11662H11.65v6.6999H9.95834Z"
}));
var _calcContentColor = function _calcContentColor(type, surface) {
  return ColorTokens.elements.primary["on".concat(surface)].value;
};
var _animateIn = function _animateIn(containerHeight) {
  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(-", "px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n"])), containerHeight);
};
var _animateOut = function _animateOut(containerHeight) {
  return keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(-", "px);\n    opacity: 0;\n  }\n"])), containerHeight);
};
var _calcBackgroundColor = function _calcBackgroundColor(type, surface) {
  switch (type) {
    case 'error':
      return ColorTokens.feedback.error.background["on".concat(surface)].value;
    case 'success':
      return ColorTokens.feedback.success.background["on".concat(surface)].value;
    case 'warning':
      return ColorTokens.feedback.warning.background["on".concat(surface)].value;
    case 'info':
    default:
      return ColorTokens.feedback.information.background["on".concat(surface)].value;
  }
};
var _calcNotificationIconSize = function _calcNotificationIconSize(viewport) {
  return viewport === 'mobile' ? 'small' : 'medium';
};
var _calcCloseIconSize = function _calcCloseIconSize(viewport) {
  return viewport === 'mobile' ? 'small' : 'medium';
};
var _calcPadding = function _calcPadding(viewport) {
  return viewport === 'mobile' ? calculateRem(LayoutTokens.space['4X'].value) : calculateRem(LayoutTokens.space['5X'].value);
};
var _calcNotificationIconMarginRight = function _calcNotificationIconMarginRight(viewport) {
  return viewport === 'mobile' ? calculateRem(LayoutTokens.space['2X'].value) : calculateRem(LayoutTokens.space['3X'].value);
};
var _getCloseButtonHeight = function _getCloseButtonHeight(viewport, closeButtonHeight) {
  if (closeButtonHeight) return closeButtonHeight;
  return viewport === 'mobile' ? calculateRem(16) : calculateRem(20);
};
var _getMinHeight = function _getMinHeight(viewport, minHeight) {
  if (minHeight) return minHeight;
  return viewport === 'mobile' ? '48px' : '60px';
};
var _getTitleSize = function _getTitleSize(viewport, titleSize) {
  if (titleSize) return titleSize;
  return viewport === 'mobile' ? 'small' : 'large';
};
var _getSubtitleSize = function _getSubtitleSize(viewport, subtitleSize) {
  if (subtitleSize) return subtitleSize;
  return viewport === 'mobile' ? 'small' : 'large';
};
var _calcInlineMargin = function _calcInlineMargin(viewport) {
  return viewport === 'mobile' ? calculateRem(LayoutTokens.space['4X'].value) : calculateRem(LayoutTokens.space['5X'].value);
};
var _getButtonGroupPaddingLeft = function _getButtonGroupPaddingLeft(viewport, buttonGroupPaddingLeft) {
  if (buttonGroupPaddingLeft) return buttonGroupPaddingLeft;
  return viewport === 'mobile' ? calculateRem(28) : calculateRem(LayoutTokens.space['8X'].value);
};
var _calcIconActiveColor = function _calcIconActiveColor(surface) {
  return ColorTokens.interactive.active["on".concat(surface)].value;
};
var _getFocusringColor = function _getFocusringColor(surface, focusringColor) {
  if (focusringColor) return focusringColor;
  return AccessibilityTokens.color.focusring["on".concat(surface)].value;
};
var propTypes = {
  /**
   * If provided, will render the contents of the Notification. The use of this prop is mutually exclusive with title/subtitle/buttonData prop.
   * @note If you want to leverage out of the box accessibility, be sure to use the provided title/subtitle/buttonData props. Otherwise, you are responsible for making sure the component is fully accessible.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If true, will disable entrance and exit animations for this component.
   */
  disableAnimation: PropTypes.bool,
  /**
   * A callback that is executed when the close button is clicked.
   */
  onCloseButtonClick: PropTypes.func,
  /**
   * Add this attribute determine your type of Notification.
   */
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
  /**
   * This will allow you to programmatically control the opened state of the notification.
   * @note When controling the notification's state be sure to use the onCloseButtonClick prop to allow a user to close the notification using the close button.
   */
  opened: PropTypes.bool,
  /**
   * If true, will hide the close button.
   */
  hideCloseButton: PropTypes.bool,
  /**
   * If true, will disable the force focus of the notification close button on instantiation.
   */
  disableFocus: PropTypes.bool,
  /**
   * @ignore
   * adds max-width to notification container
   */
  maxWidth: PropTypes.string,
  /**
   * @ignore
   * adds min-height to notification container
   */
  minHeight: PropTypes.string,
  /**
   * When used outside the grid, if set to true will allow the component to take up 100% width while centering the content in a 1272px container.
   */
  fullBleed: PropTypes.bool,
  /**
   * @ignore
   * creates animation in
   */
  animateIn: PropTypes.func,
  /**
   * @ignore
   * creates animation out
   */
  animateOut: PropTypes.func,
  /**
   * @ignore
   * defines properties of the animations on animateIn and animateOut
   */
  animationProperties: PropTypes.string,
  /**
   * @ignore
   * used for title typogrpahy
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * @ignore
   * used for subtitle typography
   */
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * @ignore
   * If provided, Button components will be rendered based on this data
   */
  buttonData: PropTypes.arrayOf(PropTypes.shape({
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    onClick: PropTypes.func
  })),
  /**
   * @ignore
   */
  unMountTime: PropTypes.number,
  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,
  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,
  /**
   * Allows a string to be provided for ignoring analytics tagging.
   */
  'data-track-ignore': PropTypes.string,
  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,
  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-level': PropTypes.string,
  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-position': PropTypes.string,
  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-datatrack': PropTypes.string,
  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-cta': PropTypes.string,
  /**
   * Allows an id to be passed to the outermost wrapper of the component
   */
  id: PropTypes.string,
  /**
   * @ignore If passed, the Body component from VDS will render
   */
  Body: PropTypes.func,
  /**
   * @ignore If passed, the ButtonGroup component from VDS will render
   */
  ButtonGroup: PropTypes.func,
  /**
   * Viewport to configure how the Notification will be rendered.
   */
  viewport: PropTypes.oneOf(['mobile', 'desktop', 'tablet']),
  /**
   * @ignore
   * If provided, will render border-radius value of notification.
   * Defaults to 4px for 3.0 and 0px for 1.0
   */
  borderRadius: PropTypes.number,
  /**
   * @ignore
   * Function to render background color
   */
  calcBackgroundColor: PropTypes.func,
  /**
   * @ignore
   */
  surface: PropTypes.oneOf(['light', 'dark']),
  /**
   * @ignore
   * If provided, will render the button group inverted for type success or info
   */
  fixedButtonInversion: PropTypes.bool,
  /**
   * @ignore
   * If provided, will render the text color
   */
  calcContentColor: PropTypes.func,
  /**
   * @ignore
   * If provided, will render the icon size for notificationIcon.
   * Defaults to small for mobile for 3.0 & medium for desktop and medium for 1.0
   */
  calcNotificationIconSize: PropTypes.func,
  /**
   * @ignore
   * If provided, will render the padding bottom of title when there is subtitle
   * Defaults to 4 for 3.0 and 0 for 1.0
   */
  titlePaddingBottom: PropTypes.number,
  /**
   * @ignore
   * focusRing border
   */
  focusringBorderRadius: PropTypes.string,
  /**
   * @ignore
   * Function to calculate close icon size
   */
  calcCloseIconSize: PropTypes.func,
  /**
   * @ignore
   * Function to render padding. 20px for 1.0
   */
  calcPadding: PropTypes.func,
  /**
   * @ignore
   * Function to calculate margin-right of notification icon wrapper
   */
  calcNotificationIconMarginRight: PropTypes.func,
  /**
   * @ignore
   * To determine the close button height
   * 3.0: desktop 20px + mobile 18px
   * 1.0: 18px
   */
  closeButtonHeight: PropTypes.string,
  /**
   * @ignore
   * Value to title size
   */
  titleSize: PropTypes.oneOf(['small', 'large']),
  /**
   * @ignore
   * Value to subtitle size
   */
  subtitleSize: PropTypes.oneOf(['small', 'large']),
  /**
   * @ignore
   * Function to calculate margin when inline is set to true
   */
  calcInlineMargin: PropTypes.func,
  /**
   * @ignore
   * Value for padding left for ButtonAreaWrapper
   * when in different viewports
   */
  buttonGroupPaddingLeft: PropTypes.string,
  /**
   * @ignore
   * Color for when close icon is active
   */
  calcIconActiveColor: PropTypes.func,
  /**
   * @ignore
   * Color value for focusring for close button
   */
  focusringColor: PropTypes.string
};
var defaultProps = {
  children: null,
  className: null,
  disableAnimation: false,
  ButtonGroup: ButtonGroup,
  onCloseButtonClick: function onCloseButtonClick() {},
  //added after renaming
  type: 'success',
  opened: false,
  hideCloseButton: false,
  disableFocus: false,
  fullBleed: false,
  maxWidth: '1272px',
  animateIn: _animateIn,
  animateOut: _animateOut,
  animationProperties: '0.35s cubic-bezier(0.22, 0.61, 0.36, 1) 0s normal 1 both',
  unMountTime: 350,
  Body: Body,
  viewport: 'desktop',
  // Brand 3
  borderRadius: 4,
  titlePaddingBottom: 4,
  surface: 'light',
  fixedButtonInversion: false,
  focusringBorderRadius: calculateRem(2),
  calcContentColor: _calcContentColor,
  calcBackgroundColor: _calcBackgroundColor,
  calcNotificationIconSize: _calcNotificationIconSize,
  calcCloseIconSize: _calcCloseIconSize,
  calcPadding: _calcPadding,
  calcNotificationIconMarginRight: _calcNotificationIconMarginRight,
  calcInlineMargin: _calcInlineMargin,
  calcIconActiveColor: _calcIconActiveColor
};
var StyledDiv = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledDiv",
  componentId: "VDS__sc-1383qpl-0"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  max-width: ", ";\n  width: 100%;\n  outline: none;\n  &:focus {\n    outline: none;\n  }\n"])), function (_ref) {
  var maxWidth = _ref.maxWidth,
    fullBleed = _ref.fullBleed;
  return fullBleed ? null : maxWidth;
});
var TitleWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TitleWrapper",
  componentId: "VDS__sc-1383qpl-1"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding-bottom: ", ";\n"])), function (_ref2) {
  var titlePaddingBottom = _ref2.titlePaddingBottom;
  return calculateRem(titlePaddingBottom);
});
var AlertWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "AlertWrapper",
  componentId: "VDS__sc-1383qpl-2"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  opacity: 0;\n  overflow: hidden;\n  box-sizing: border-box;\n  padding: ", ";\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: ", ";\n  opacity: 0;\n  margin: 0\n    ", ";\n  min-height: ", ";\n  ", ";\n\n  transition: ", ";\n\n  ", ";\n  ", ";\n\n  outline: none;\n  @media screen and (max-width: ", ") {\n    box-sizing: border-box;\n\n    padding: ", ";\n    transition: ", ";\n    ", ";\n    ", ";\n  }\n\n  &:active,\n  &:visited,\n  &:hover {\n    outline: none;\n  }\n  * {\n    &:active,\n    &:visited,\n    &:hover {\n      outline: none;\n    }\n  }\n"])), function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, function (_ref4) {
  var borderRadius = _ref4.borderRadius,
    fullBleed = _ref4.fullBleed;
  return fullBleed ? 0 : calculateRem(borderRadius);
}, function (_ref5) {
  var padding = _ref5.padding;
  return padding;
}, function (_ref6) {
  var fullBleed = _ref6.fullBleed;
  return fullBleed ? 'center' : 'space-between';
}, function (_ref7) {
  var inline = _ref7.inline,
    fullBleed = _ref7.fullBleed,
    inlineMargin = _ref7.inlineMargin;
  return inline && !fullBleed ? inlineMargin : 0;
}, function (_ref8) {
  var minHeight = _ref8.minHeight;
  return minHeight;
}, function (_ref9) {
  var textShadow = _ref9.textShadow,
    type = _ref9.type;
  return textShadow && "\n  text-shadow: 0 0 0.01px ".concat(type === 'warning' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value, ";\n  ");
}, function (_ref10) {
  var disableAnimation = _ref10.disableAnimation;
  return disableAnimation ? 0 : 'all ease 0.2s';
}, function (_ref11) {
  var disableAnimation = _ref11.disableAnimation,
    animateIn = _ref11.animateIn,
    containerHeight = _ref11.containerHeight,
    animationProperties = _ref11.animationProperties;
  return !disableAnimation && containerHeight && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      animation: ", " ", ";\n    "])), animateIn(containerHeight), animationProperties);
}, function (_ref12) {
  var unmounted = _ref12.unmounted,
    animateOut = _ref12.animateOut,
    containerHeight = _ref12.containerHeight,
    animationProperties = _ref12.animationProperties;
  return unmounted && containerHeight && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      animation: ", " ", ";\n    "])), animateOut(containerHeight), animationProperties);
}, breakpoints.md, calculateRem(16), function (_ref13) {
  var disableAnimation = _ref13.disableAnimation;
  return disableAnimation ? 0 : 'all ease 0.2s';
}, function (_ref14) {
  var disableAnimation = _ref14.disableAnimation,
    animateIn = _ref14.animateIn,
    containerHeight = _ref14.containerHeight,
    animationProperties = _ref14.animationProperties;
  return !disableAnimation && containerHeight && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        animation: ", " ", ";\n      "])), animateIn(containerHeight), animationProperties);
}, function (_ref15) {
  var unmounted = _ref15.unmounted,
    animateOut = _ref15.animateOut,
    containerHeight = _ref15.containerHeight,
    animationProperties = _ref15.animationProperties;
  return unmounted && containerHeight && css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        animation: ", " ", ";\n      "])), animateOut(containerHeight), animationProperties);
});
var TextAreaWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TextAreaWrapper",
  componentId: "VDS__sc-1383qpl-3"
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: ", ";\n  justify-content: space-between;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  word-break: break-word;\n  overflow-wrap: break-word;\n\n  @media screen and (min-width: ", ") {\n    ", ";\n  }\n  @media screen and (max-width: ", ") {\n    ", ";\n  }\n\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"])), function (_ref16) {
  var isIe = _ref16.isIe;
  return isIe ? "1 1 0" : "1 1 0%";
}, breakpoints.lg, function (_ref17) {
  var layout = _ref17.layout,
    halfWidth = _ref17.halfWidth,
    paddingRight = _ref17.paddingRight;
  return layout !== 'horizontal' && layout !== 'vertical' && "\n        max-width: ".concat(halfWidth ? '50%' : '100%', ";\n        padding-right: ").concat(halfWidth ? calculateRem(LayoutTokens.space['5X'].value) : paddingRight, ";\n    ");
}, breakpoints.lg, function (_ref18) {
  var layout = _ref18.layout,
    paddingRight = _ref18.paddingRight;
  return layout !== 'horizontal' && "\n      padding-right: ".concat(paddingRight, ";\n      max-width: 100%;\n    ");
}, function (_ref19) {
  var viewport = _ref19.viewport,
    layout = _ref19.layout,
    halfWidth = _ref19.halfWidth,
    paddingRight = _ref19.paddingRight;
  return layout !== 'horizontal' && layout !== 'vertical' && viewport === 'desktop' && "\n      max-width: ".concat(halfWidth ? '50%' : '100%', ";\n      padding-right: ").concat(halfWidth ? calculateRem(LayoutTokens.space['5X'].value) : paddingRight, ";\n  ");
}, function (_ref20) {
  var viewport = _ref20.viewport,
    layout = _ref20.layout,
    paddingRight = _ref20.paddingRight;
  return layout !== 'horizontal' && viewport !== 'desktop' && "\n      max-width: 100%;\n      padding-right: ".concat(paddingRight, ";\n  ");
}, function (_ref21) {
  var layout = _ref21.layout,
    viewport = _ref21.viewport,
    paddingRight = _ref21.paddingRight;
  return layout === 'vertical' && viewport === 'desktop' && "\n      max-width: 100%;\n      padding-right: ".concat(paddingRight, ";\n  ");
}, function (_ref22) {
  var layout = _ref22.layout,
    halfWidth = _ref22.halfWidth,
    paddingRight = _ref22.paddingRight;
  return layout === 'horizontal' && "\n      max-width: ".concat(halfWidth ? '50%' : '100%', ";\n      padding-right: ").concat(halfWidth ? calculateRem(LayoutTokens.space['5X'].value) : paddingRight, ";\n  ");
});
var ButtonAreaWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ButtonAreaWrapper",
  componentId: "VDS__sc-1383qpl-4"
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: ", ";\n  justify-content: space-between;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  padding-right: ", ";\n  @media screen and (min-width: ", ") {\n    ", ";\n  }\n  @media screen and (max-width: ", ") {\n    ", ";\n  }\n\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"])), function (_ref23) {
  var isIe = _ref23.isIe;
  return isIe ? "1 1 0" : "1 1 0%";
}, function (_ref24) {
  var paddingRight = _ref24.paddingRight;
  return paddingRight;
}, breakpoints.lg, function (_ref25) {
  var layout = _ref25.layout,
    viewport = _ref25.viewport,
    buttonGroupPaddingLeft = _ref25.buttonGroupPaddingLeft;
  return viewport !== 'desktop' && layout !== 'horizontal' && layout !== 'vertical' && "\n        max-width: 50%;\n        padding-left: ".concat(_getButtonGroupPaddingLeft(viewport, buttonGroupPaddingLeft), ";\n    ");
}, breakpoints.lg, function (_ref26) {
  var layout = _ref26.layout,
    viewport = _ref26.viewport,
    buttonGroupPaddingLeft = _ref26.buttonGroupPaddingLeft;
  return layout !== 'horizontal' && "\n      max-width: 100%;\n      padding-left: ".concat(_getButtonGroupPaddingLeft(viewport, buttonGroupPaddingLeft), ";\n    };\n    ");
}, function (_ref27) {
  var viewport = _ref27.viewport,
    layout = _ref27.layout;
  return layout !== 'horizontal' && layout !== 'vertical' && viewport === 'desktop' && "\n      max-width: 50%;\n      padding-left: ".concat(calculateRem(LayoutTokens.space['5X'].value), ";\n\n  ");
}, function (_ref28) {
  var viewport = _ref28.viewport,
    layout = _ref28.layout;
  return layout !== 'horizontal' && viewport !== 'desktop' && "\n      max-width: 100%;\n      padding-left: ".concat(calculateRem(LayoutTokens.space['8X'].value), ";\n  ");
}, function (_ref29) {
  var layout = _ref29.layout;
  return layout === 'vertical' && "\n      max-width: 100%;\n      padding-left: ".concat(calculateRem(LayoutTokens.space['8X'].value), ";\n  ");
}, function (_ref30) {
  var layout = _ref30.layout;
  return layout === 'horizontal' && "\n      max-width: 50%;\n      padding-left: ".concat(calculateRem(LayoutTokens.space['5X'].value), ";\n  ");
});
var TextWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "TextWrapper",
  componentId: "VDS__sc-1383qpl-5"
})(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  flex-direction: column;\n  flex: 1;\n  display: flex;\n"])));
var Title = /*#__PURE__*/styled.div.withConfig({
  displayName: "Title",
  componentId: "VDS__sc-1383qpl-6"
})(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  color: ", ";\n  max-width: 80%;\n  outline: none;\n  font-family: ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  return props.color;
}, Fonts.VerizonNHGeDS, function (_ref31) {
  var desktopConfig = _ref31.desktopConfig,
    mobileConfig = _ref31.mobileConfig,
    color = _ref31.color;
  return "\n    font-size: ".concat(calculateRem(desktopConfig.fontSize), ";\n    line-height: ").concat(calculateRem(desktopConfig.lineHeight), ";\n    letter-spacing: ").concat(calculateRem(desktopConfig.letterSpacing), ";\n    font-weight: ").concat(desktopConfig.bold, ";\n    color: ").concat(color, ";\n    @media screen and (max-width: ").concat(breakpoints.md, ") {\n      max-width: 80%;\n      padding-bottom: 0;\n      outline: none;\n      font-size: ").concat(calculateRem(mobileConfig.fontSize), ";\n      line-height: ").concat(calculateRem(mobileConfig.lineHeight), ";\n      letter-spacing: ").concat(calculateRem(mobileConfig.letterSpacing), ";\n      font-weight: ").concat(mobileConfig.bold, ";\n    }\n  ");
}, function (_ref32) {
  var viewport = _ref32.viewport,
    mobileConfig = _ref32.mobileConfig;
  return viewport === 'mobile' && "\n    max-width: 80%;\n    padding-bottom: 0;\n    outline: none;\n    font-size: ".concat(calculateRem(mobileConfig.fontSize), ";\n    line-height: ").concat(calculateRem(mobileConfig.lineHeight), ";\n    letter-spacing: ").concat(calculateRem(mobileConfig.letterSpacing), ";\n    font-weight: ").concat(mobileConfig.bold, ";\n  ");
});
var ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ContentWrapper",
  componentId: "VDS__sc-1383qpl-7"
})(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  position: relative;\n  max-width: 1272px;\n  justify-content: ", ";\n\n  @media screen and (max-width: ", ") {\n    overflow: visible;\n  }\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref33) {
  var contentTitle = _ref33.contentTitle,
    subtitle = _ref33.subtitle;
  return !contentTitle && !subtitle && 'space-between';
}, breakpoints.sm, function (_ref34) {
  var viewport = _ref34.viewport;
  return (viewport === 'tablet' || viewport === 'mobile') && "\n    flex-direction: column;\n  ";
}, function (_ref35) {
  var layout = _ref35.layout;
  return layout === 'vertical' && "\n    flex-direction: column;\n  ";
}, function (_ref36) {
  var layout = _ref36.layout;
  return layout === 'horizontal' && "\n    flex-direction: row;\n  ";
});
var NotificationIconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "NotificationIconWrapper",
  componentId: "VDS__sc-1383qpl-8"
})(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  margin-right: ", ";\n  display: flex;\n"])), function (_ref37) {
  var marginRight = _ref37.marginRight;
  return marginRight;
});

//margin-bottom is applied to cancel out the padding-bottom applied to ButtonGroup component
var ButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ButtonWrapper",
  componentId: "VDS__sc-1383qpl-9"
})(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  ", "\n  margin-bottom: ", ";\n\n  flex: 1;\n  display: flex;\n  align-items: center;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  @media screen and (max-width: ", ") {\n    width: inherit;\n  }\n  button {\n    margin: 0;\n  }\n"])), function (_ref38) {
  var noButtonPadding = _ref38.noButtonPadding;
  return noButtonPadding && "\n    div > div {\n      padding-right: 0;\n      padding-bottom: 0;\n    };\n  ";
}, function (_ref39) {
  var buttonData = _ref39.buttonData;
  return buttonData && buttonData.length === 1 ? 0 : "-".concat(calculateRem(LayoutTokens.space['3X'].value));
}, function (_ref40) {
  var layout = _ref40.layout,
    viewport = _ref40.viewport;
  return viewport !== 'desktop' && layout !== 'vertical' && layout !== 'horizontal' && "\n    @media screen and (min-width: ".concat(breakpoints.lg, ") {\n      margin-top: ").concat(calculateRem(12), ";\n      margin-left: 0;\n    }\n  ");
}, function (_ref41) {
  var viewport = _ref41.viewport,
    layout = _ref41.layout;
  return viewport === 'desktop' && layout !== 'vertical' && layout !== 'horizontal' && "\n    margin-top: 0;\n    margin-left: 0;\n  ";
}, function (_ref42) {
  var layout = _ref42.layout,
    viewport = _ref42.viewport;
  return viewport !== 'desktop' && layout !== 'vertical' && layout !== 'horizontal' && "\n    @media screen and (max-width: ".concat(breakpoints.lg, ") {\n      margin-top: ").concat(calculateRem(12), ";\n      margin-left: 0;\n    }\n  ");
}, function (_ref43) {
  var viewport = _ref43.viewport,
    layout = _ref43.layout;
  return viewport !== 'desktop' && layout !== 'vertical' && layout !== 'horizontal' && "\n    margin-top: ".concat(calculateRem(12), ";\n    margin-left: 0;\n  ");
}, function (_ref44) {
  var layout = _ref44.layout;
  return layout === 'horizontal' && "\n      margin-top: 0;\n      margin-left: 0;\n  ";
}, function (_ref45) {
  var layout = _ref45.layout;
  return layout === 'vertical' && "\n      margin-top: ".concat(calculateRem(12), ";\n      margin-left: 0;\n  ");
}, breakpoints.sm);
var TextIconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TextIconWrapper",
  componentId: "VDS__sc-1383qpl-10"
})(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n"])));

// Necessary to concatenate type notification with title for screen readers
var AccessibilityLabel = /*#__PURE__*/styled.span.attrs(function () {
  return {
    ariaHidden: true
  };
}).withConfig({
  displayName: "AccessibilityLabel",
  componentId: "VDS__sc-1383qpl-11"
})(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  whitespace: nowrap;\n  border: 0;\n"])));
var IconSVGWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "IconSVGWrapper",
  componentId: "VDS__sc-1383qpl-12"
})(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  ", ";\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  svg {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_ref46) {
  var iconSize = _ref46.iconSize;
  return calculateRem(iconSize);
}, function (_ref47) {
  var iconSize = _ref47.iconSize;
  return calculateRem(iconSize);
}, function (_ref48) {
  var iconSize = _ref48.iconSize;
  return calculateRem(iconSize);
}, function (_ref49) {
  var iconSize = _ref49.iconSize;
  return calculateRem(iconSize);
}, function (_ref50) {
  var tabIndex = _ref50.tabIndex;
  return tabIndex < 0 && "\n    outline: none;\n    pointer-events: none;\n  ";
}, function (_ref51) {
  var iconColor = _ref51.iconColor;
  return iconColor;
});
var Notification = /*#__PURE__*/function (_Component) {
  _inherits(Notification, _Component);
  var _super = _createSuper(Notification);
  function Notification(props) {
    var _this;
    _classCallCheck(this, Notification);
    _this = _super.call(this, props);
    // Used to calculate paddingRight of sections (text or button area depending on the orientation) to closeButton
    // Determined based in the closeIcon size passed in
    _defineProperty(_assertThisInitialized(_this), "_getPaddingRight", function () {
      var _this$props = _this.props,
        calcCloseIconSize = _this$props.calcCloseIconSize,
        viewport = _this$props.viewport,
        hideCloseButton = _this$props.hideCloseButton;
      var ICON_SIZE = calcCloseIconSize(viewport);
      var baseIconPadding = 12; // specs

      if (hideCloseButton) return 0;
      switch (ICON_SIZE) {
        case 'medium':
          return calculateRem(baseIconPadding + 20);
        // 20 is the size of icon medium
        case 'small':
        default:
          return calculateRem(baseIconPadding + 16);
        // 16 is the size of icon small
      }
    });
    // role text for iOS devices
    _defineProperty(_assertThisInitialized(_this), "isAppleDevice", function () {
      if (typeof navigator === 'undefined') return false;
      return /iPhone|iPad/i.test(navigator.userAgent);
    }());
    _defineProperty(_assertThisInitialized(_this), "_checkIfIe", getBrowser() === 'ie');
    _defineProperty(_assertThisInitialized(_this), "close", function () {
      var disableAnimation = _this.props.disableAnimation;
      if (!disableAnimation) {
        _this.setState(function () {
          return {
            unmounted: true
          };
        });
        _this.props.onCloseButtonClick();
        _this.unMountTimer = setTimeout(function () {
          _this.setState({
            visible: false
          });
        }, _this.props.unMountTime);
      } else {
        _this.setState(function () {
          return {
            visible: false
          };
        });
        _this.props.onCloseButtonClick();
      }
      _this.wrapper && _this.wrapper.blur();
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props2 = _this.props,
        disableFocus = _this$props2.disableFocus,
        hideCloseButton = _this$props2.hideCloseButton;
      _this.setState({
        containerHeight: _this.wrapper ? _this.wrapper.clientHeight : _this.props.minHeight || '100%'
      });
      _this.roleTimer = setTimeout(function () {
        _this.setState({
          role: 'text'
        });
      }, _this.props.unMountTime);
      !disableFocus && typeof document !== 'undefined' && document.getElementById(_this.notificationCloseButtonID) && document.getElementById(_this.notificationCloseButtonID).focus();
      !disableFocus && typeof document !== 'undefined' && hideCloseButton && document.getElementById(_this.buttonID) && document.getElementById(_this.buttonID).focus();
      setTimeout(function () {
        _this.setState({
          isFirstFocus: false
        });
      }, 500);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearTimeout(_this.unMountTimer);
      clearTimeout(_this.roleTimer);
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props3 = _this.props,
        hideCloseButton = _this$props3.hideCloseButton,
        opened = _this$props3.opened;
      if (hideCloseButton && prevProps.opened !== opened) {
        _this.setState(function () {
          return {
            visible: !prevProps.opened
          };
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderIconElement", function () {
      var _this$props4 = _this.props,
        type = _this$props4.type,
        hideCloseButton = _this$props4.hideCloseButton,
        closeButtonHeight = _this$props4.closeButtonHeight,
        buttonData = _this$props4.buttonData,
        cta = _this$props4['data-sitecat-cta'],
        dataTrack = _this$props4['data-sitecat-datatrack'],
        position = _this$props4['data-sitecat-position'],
        level = _this$props4['data-sitecat-level'],
        calcContentColor = _this$props4.calcContentColor,
        surface = _this$props4.surface,
        calcCloseIconSize = _this$props4.calcCloseIconSize,
        viewport = _this$props4.viewport,
        focusringBorderRadius = _this$props4.focusringBorderRadius,
        calcIconActiveColor = _this$props4.calcIconActiveColor,
        focusringColor = _this$props4.focusringColor;
      var _this$state = _this.state,
        visible = _this$state.visible,
        isFirstFocus = _this$state.isFirstFocus;
      if (!hideCloseButton) {
        return /*#__PURE__*/React.createElement(NotificationClose, {
          id: _this.notificationCloseButtonID,
          focusringBorderRadius: focusringBorderRadius,
          closeButtonHeight: _getCloseButtonHeight(viewport, closeButtonHeight),
          contentColor: calcContentColor(type, surface),
          size: calcCloseIconSize(viewport),
          type: type,
          controlFunc: _this.close,
          visible: visible,
          buttonData: buttonData,
          cta: cta,
          dataTrack: dataTrack,
          position: position,
          level: level,
          isFirstFocus: isFirstFocus,
          surface: surface,
          iconActiveColor: calcIconActiveColor(surface),
          focusringColor: _getFocusringColor(surface, focusringColor)
        });
      }
      return null;
    });
    _defineProperty(_assertThisInitialized(_this), "renderNotificationIcon", function () {
      var _this$props5 = _this.props,
        type = _this$props5.type,
        calcContentColor = _this$props5.calcContentColor,
        surface = _this$props5.surface,
        viewport = _this$props5.viewport,
        calcNotificationIconMarginRight = _this$props5.calcNotificationIconMarginRight,
        calcNotificationIconSize = _this$props5.calcNotificationIconSize;
      var _renderIconSize = function _renderIconSize() {
        var size = calcNotificationIconSize(viewport);
        switch (size) {
          case 'medium':
            return 20;
          default:
            return 16;
          // small
        }
      };

      var _getIcons = function _getIcons() {
        switch (type) {
          case 'success':
            return SuccessIcon;
          case 'warning':
            return WarningIcon;
          case 'info':
            return InfoIcon;
          case 'error':
            return ErrorIcon;
        }
      };
      return /*#__PURE__*/React.createElement(NotificationIconWrapper, {
        tabIndex: -1,
        "aria-hidden": true,
        marginRight: calcNotificationIconMarginRight(viewport)
      }, /*#__PURE__*/React.createElement(IconSVGWrapper, {
        tabIndex: -1,
        "aria-hidden": true,
        iconColor: calcContentColor(type, surface),
        iconSize: _renderIconSize(),
        "aria-label": "".concat(type === 'success' ? 'checkmark-alt' : type, " icon")
      }, _getIcons()));
    });
    _defineProperty(_assertThisInitialized(_this), "_determineTitleConfig", function () {
      return {
        desktop: {
          fontSize: TypographyTokens.fontsize.body[16].value,
          lineHeight: TypographyTokens.lineheight.body[20].value,
          letterSpacing: TypographyTokens.letterspacing.wide.value,
          bold: TypographyTokens.fontweight.bold.value
        },
        mobile: {
          fontSize: TypographyTokens.fontsize.body[16].value,
          lineHeight: TypographyTokens.lineheight.body[20].value,
          letterSpacing: TypographyTokens.letterspacing.wide.value,
          bold: TypographyTokens.fontweight.bold.value
        }
      };
    });
    _defineProperty(_assertThisInitialized(_this), "renderText", function () {
      var _this$props6 = _this.props,
        type = _this$props6.type,
        title = _this$props6.title,
        subtitle = _this$props6.subtitle,
        children = _this$props6.children,
        Body = _this$props6.Body,
        buttonData = _this$props6.buttonData,
        viewport = _this$props6.viewport,
        layout = _this$props6.layout,
        calcContentColor = _this$props6.calcContentColor,
        surface = _this$props6.surface,
        titlePaddingBottom = _this$props6.titlePaddingBottom,
        titleSize = _this$props6.titleSize,
        subtitleSize = _this$props6.subtitleSize,
        disableFocus = _this$props6.disableFocus;
      if (title && !subtitle) {
        return /*#__PURE__*/React.createElement(TextAreaWrapper, {
          halfWidth: buttonData !== undefined,
          viewport: viewport,
          layout: layout,
          isIe: _this._checkIfIe,
          paddingRight: _this._getPaddingRight()
        }, /*#__PURE__*/React.createElement(TextIconWrapper, {
          role: _this.isAppleDevice.toString() === 'true' || !disableFocus ? 'alert' : undefined,
          "aria-live": disableFocus ? 'polite' : 'assertive'
        }, _this.renderNotificationIcon(), /*#__PURE__*/React.createElement(TextWrapper, {
          viewport: viewport,
          layout: layout,
          "aria-labelledby": disableFocus ? _this.typeID : undefined,
          role: _this.isAppleDevice.toString() === 'true' ? 'text' : _this.state.role // necessary for VoiceOver
        }, /*#__PURE__*/React.createElement(AccessibilityLabel, {
          id: _this.typeID
        }, _this.isAppleDevice.toString() === 'true' && disableFocus ? "".concat(disableFocus ? 'Alert!' : '', " ").concat(type === 'info' ? 'information' : type, " notification ").concat(title) : "".concat(disableFocus ? 'Alert!' : '', " ").concat(type === 'info' ? 'information' : type, " notification")), /*#__PURE__*/React.createElement(Body, {
          id: _this.titleID,
          bold: true,
          size: _getTitleSize(viewport, titleSize),
          color: calcContentColor(type, surface)
        }, title))), (layout === 'vertical' || buttonData === undefined) && _this.renderIconElement());
      } else if (title && subtitle) {
        return /*#__PURE__*/React.createElement(TextAreaWrapper, {
          halfWidth: buttonData !== undefined,
          viewport: viewport,
          layout: layout,
          isIe: _this._checkIfIe,
          paddingRight: _this._getPaddingRight()
        }, /*#__PURE__*/React.createElement(TextIconWrapper, {
          role: _this.isAppleDevice.toString() === 'true' || !disableFocus ? 'alert' : undefined,
          "aria-live": disableFocus ? 'polite' : 'assertive'
        }, _this.renderNotificationIcon(), /*#__PURE__*/React.createElement(TextWrapper, {
          viewport: viewport,
          layout: layout,
          "aria-labelledby": disableFocus ? _this.typeID : undefined,
          role: _this.isAppleDevice.toString() === 'true' ? 'text' : _this.state.role // necessary for VoiceOver
        }, /*#__PURE__*/React.createElement(AccessibilityLabel, {
          id: _this.typeID
        }, _this.isAppleDevice.toString() === 'true' && disableFocus ? "".concat(disableFocus ? 'Alert!' : '', " ").concat(type === 'info' ? 'information' : type, " notification ").concat(title, " ").concat(subtitle) : "".concat(disableFocus ? 'Alert!' : '', " ").concat(type === 'info' ? 'information' : type, " notification")), /*#__PURE__*/React.createElement(TitleWrapper, {
          titlePaddingBottom: titlePaddingBottom
        }, /*#__PURE__*/React.createElement(Body, {
          id: _this.titleID,
          bold: true,
          size: _getTitleSize(viewport, titleSize),
          color: calcContentColor(type, surface)
        }, title)), /*#__PURE__*/React.createElement(Body, {
          id: _this.subtitleID,
          size: _getSubtitleSize(viewport, subtitleSize),
          color: calcContentColor(type, surface)
        }, subtitle))), (layout === 'vertical' || buttonData === undefined) && _this.renderIconElement());
      } else {
        return /*#__PURE__*/React.createElement(TextAreaWrapper, {
          halfWidth: buttonData !== undefined,
          viewport: viewport,
          layout: layout,
          isIe: _this._checkIfIe,
          paddingRight: _this._getPaddingRight()
        }, /*#__PURE__*/React.createElement(TextIconWrapper, {
          role: _this.isAppleDevice.toString() === 'true' || !disableFocus ? 'alert' : undefined,
          "aria-live": disableFocus ? 'polite' : 'assertive'
        }, _this.renderNotificationIcon(), /*#__PURE__*/React.createElement(TextWrapper, {
          "aria-labelledby": disableFocus ? _this.typeID : undefined,
          role: _this.isAppleDevice.toString() === 'true' ? 'text' : _this.state.role // necessary for VoiceOver
        }, /*#__PURE__*/React.createElement(AccessibilityLabel, {
          id: _this.typeID
        }, "".concat(disableFocus ? 'Alert!' : '', " ").concat(type === 'info' ? 'information' : type, " notification"), _this.isAppleDevice.toString() === 'true' && disableFocus && children), /*#__PURE__*/React.createElement(Title, {
          color: calcContentColor(type, surface),
          viewport: viewport,
          id: _this.childrenId,
          mobileConfig: _this._determineTitleConfig().mobile,
          desktopConfig: _this._determineTitleConfig().desktop
        }, children))), buttonData === undefined && _this.renderIconElement());
      }
    });
    _defineProperty(_assertThisInitialized(_this), "parseButtonData", function () {
      var _this$props7 = _this.props,
        buttonData = _this$props7.buttonData,
        type = _this$props7.type,
        fixedButtonInversion = _this$props7.fixedButtonInversion,
        hideCloseButton = _this$props7.hideCloseButton;
      var _isMobileDevice = checkIfMobileDevice();
      // 1.0: have to invert the actual buttons in ButtonGroup
      var shouldInvert = type === 'info' || type === 'success';
      var buttonDetail = [];
      buttonData.length > 2 && buttonData.splice(2);
      buttonData.forEach(function (data, index) {
        buttonDetail.push(_objectSpread({}, data));
        /* istanbul ignore else  */
        if (index === 0) {
          buttonDetail[0].id = _this.buttonID;
          if (_isMobileDevice && hideCloseButton && _this.state.isFirstFocus) {
            buttonDetail[0]['aria-live'] = 'polite';
            buttonDetail[0].ariaLabel = "".concat(buttonDetail[0].children, " button");
          }
        }
        if (index === 0 && !data.hasOwnProperty('buttonType') && index === 0 && !data.hasOwnProperty('use') || index === 1) {
          buttonDetail[index].use = 'secondary';
        }
        buttonDetail[index].size = 'small';
        if (fixedButtonInversion) {
          buttonDetail[index].inverted = shouldInvert;
        }
      });
      return buttonDetail;
    });
    _defineProperty(_assertThisInitialized(_this), "renderButtons", function () {
      var _this$props8 = _this.props,
        buttonData = _this$props8.buttonData,
        ButtonGroup = _this$props8.ButtonGroup,
        layout = _this$props8.layout,
        viewport = _this$props8.viewport,
        surface = _this$props8.surface,
        buttonGroupPaddingLeft = _this$props8.buttonGroupPaddingLeft;
      return /*#__PURE__*/React.createElement(Fragment, null, layout !== 'vertical' && buttonData && _this.renderIconElement(), /*#__PURE__*/React.createElement(ButtonAreaWrapper, {
        viewport: viewport,
        layout: layout,
        isIe: _this._checkIfIe,
        buttonGroupPaddingLeft: buttonGroupPaddingLeft,
        paddingRight: _this._getPaddingRight()
      }, /*#__PURE__*/React.createElement(ButtonWrapper, {
        layout: layout,
        viewport: viewport,
        buttonData: buttonData,
        noButtonPadding: buttonData.length === 1
      }, buttonData && /*#__PURE__*/React.createElement(ButtonGroup, {
        surface: surface // 3.0 only
        ,
        data: _this.parseButtonData()
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "renderNotificationContent", function () {
      var _this$props9 = _this.props,
        layout = _this$props9.layout,
        title = _this$props9.title,
        subtitle = _this$props9.subtitle,
        viewport = _this$props9.viewport,
        buttonData = _this$props9.buttonData;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ContentWrapper, {
        layout: layout,
        viewport: viewport,
        contentTitle: title,
        subtitle: subtitle
      }, _this.renderText(), buttonData && !!buttonData.length && _this.renderButtons()));
    });
    _defineProperty(_assertThisInitialized(_this), "renderAlertWithoutTransition", function () {
      var _this$props10 = _this.props,
        type = _this$props10.type,
        className = _this$props10.className,
        disableAnimation = _this$props10.disableAnimation,
        viewport = _this$props10.viewport,
        minHeight = _this$props10.minHeight,
        inline = _this$props10.inline,
        fullBleed = _this$props10.fullBleed,
        analyticsTrack = _this$props10['data-analyticstrack'],
        track = _this$props10['data-track'],
        trackIgnore = _this$props10['data-track-ignore'],
        clickStream = _this$props10['data-clickstream'],
        borderRadius = _this$props10.borderRadius,
        calcBackgroundColor = _this$props10.calcBackgroundColor,
        surface = _this$props10.surface,
        calcPadding = _this$props10.calcPadding,
        calcInlineMargin = _this$props10.calcInlineMargin;
      var visible = _this.state.visible;
      return /*#__PURE__*/React.createElement(AlertWrapper, {
        minHeight: _getMinHeight(viewport, minHeight),
        viewport: viewport,
        type: type,
        tabIndex: -1,
        style: {
          opacity: visible ? 1 : 0,
          height: visible ? 'auto' : 0,
          display: visible ? 'flex' : 'none'
        },
        className: className,
        "data-testid": "alert",
        disableAnimation: disableAnimation,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-track-ignore": trackIgnore,
        "data-clickstream": clickStream,
        inline: inline,
        fullBleed: fullBleed,
        borderRadius: borderRadius,
        backgroundColor: calcBackgroundColor(type, surface),
        padding: calcPadding(viewport),
        inlineMargin: calcInlineMargin(viewport)
      }, _this.renderNotificationContent());
    });
    _defineProperty(_assertThisInitialized(_this), "renderAlertWithTransition", function () {
      var _this$props11 = _this.props,
        type = _this$props11.type,
        children = _this$props11.children,
        className = _this$props11.className,
        viewport = _this$props11.viewport,
        minHeight = _this$props11.minHeight,
        animateIn = _this$props11.animateIn,
        animateOut = _this$props11.animateOut,
        animationProperties = _this$props11.animationProperties,
        inline = _this$props11.inline,
        fullBleed = _this$props11.fullBleed,
        layout = _this$props11.layout,
        analyticsTrack = _this$props11['data-analyticstrack'],
        track = _this$props11['data-track'],
        trackIgnore = _this$props11['data-track-ignore'],
        clickStream = _this$props11['data-clickstream'],
        borderRadius = _this$props11.borderRadius,
        calcBackgroundColor = _this$props11.calcBackgroundColor,
        surface = _this$props11.surface,
        calcPadding = _this$props11.calcPadding,
        calcInlineMargin = _this$props11.calcInlineMargin;
      var _this$state2 = _this.state,
        visible = _this$state2.visible,
        unmounted = _this$state2.unmounted,
        containerHeight = _this$state2.containerHeight;
      return visible && /*#__PURE__*/React.createElement(AlertWrapper, {
        animateIn: animateIn,
        animateOut: animateOut,
        animationProperties: animationProperties,
        containerHeight: containerHeight,
        minHeight: _getMinHeight(viewport, minHeight),
        viewport: viewport,
        type: type,
        "data-testid": "alert",
        unmounted: unmounted,
        tabIndex: -1,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-track-ignore": trackIgnore,
        "data-clickstream": clickStream,
        inline: inline,
        fullBleed: fullBleed,
        borderRadius: borderRadius,
        backgroundColor: calcBackgroundColor(type, surface),
        padding: calcPadding,
        inlineMargin: calcInlineMargin(viewport)
      }, _this.renderNotificationContent());
    });
    _this.state = {
      visible: true,
      unmounted: false,
      containerHeight: 0,
      role: undefined,
      isFirstFocus: true
    };
    // custom id's in order to use aria-* properties
    _this.titleID = "title_".concat(generateUUID());
    _this.subtitleID = "subtitle_".concat(generateUUID());
    _this.typeID = "type_".concat(generateUUID());
    _this.childrenId = "children_".concat(generateUUID());
    _this.notificationCloseButtonID = "notificationCloseButton_".concat(generateUUID());
    _this.buttonID = "button_".concat(generateUUID());
    return _this;
  }
  _createClass(Notification, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props12 = this.props,
        disableAnimation = _this$props12.disableAnimation,
        fullBleed = _this$props12.fullBleed,
        maxWidth = _this$props12.maxWidth,
        id = _this$props12.id,
        className = _this$props12.className;
      return /*#__PURE__*/React.createElement(StyledDiv, {
        id: id,
        className: className,
        maxWidth: maxWidth,
        fullBleed: fullBleed,
        containerHeight: this.state.containerHeight,
        tabIndex: -1,
        innerRef: function innerRef(input) {
          _this2.wrapper = input;
        }
      }, disableAnimation ? this.renderAlertWithoutTransition() : this.renderAlertWithTransition());
    }
  }]);
  return Notification;
}(Component);
Notification.propTypes = propTypes;
Notification.defaultProps = defaultProps;
export default withVDSManager(Notification);